import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private isMaintenanceMode$ = new BehaviorSubject<boolean>(false);
  private maintenanceMessage$ = new BehaviorSubject<string>('');

  get isMaintenanceMode(): Observable<boolean> {
    return this.isMaintenanceMode$.asObservable();
  }

  get maintenanceMessage(): Observable<string> {
    return this.maintenanceMessage$.asObservable();
  }

  get currentMaintenanceMessage(): string {
    return this.maintenanceMessage$.getValue();
  }

  get currentIsMaintenanceMode(): boolean {
    return this.isMaintenanceMode$.getValue();
  }

  setMaintenanceMode(isEnabled: boolean, message: string = ''): void {
    this.isMaintenanceMode$.next(isEnabled);
    this.maintenanceMessage$.next(message);
  }

  clearMaintenanceMode(): void {
    this.isMaintenanceMode$.next(false);
    this.maintenanceMessage$.next('');
  }
}
